"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  name: "רועי כהן",
  role: "לקוח קבוע",
  quote: "הבריסקט פשוט נמס בפה. הטעם המעושן היה מדויק, לא משתלט מדי אבל נוכח בכל ביס. חוויה של מסעדת שף אצלי בסלון.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/avatar_roi_cohen.png",
  rating: 5
}, {
  name: "דנה לוי",
  role: "פודית",
  quote: "הזמנו ארוחה משפחתית לשישי בערב. המשלוח הגיע חם, ארוז בצורה אסתטית והבשר... וואו. האסאדו היה מושלם, והתוספות היו טריות ומרעננות.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/avatar_dana_levi.png",
  rating: 5
}, {
  name: "ירון מזרחי",
  role: "קרניבור",
  quote: "בתור חובב בשר מושבע, קשה להרשים אותי. SMOKE & GO הצליחו בגדול. התיבול הייחודי והאיכות של הבשר הם ברמה אחרת לגמרי ממה שהכרתי.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/avatar_yaron_mizrahi.png",
  rating: 5
}];
export default function CarnivoreTestimonials() {
  return <section id="מה-אומרים-הקרניבורים" className="dark bg-background text-foreground relative overflow-hidden py-24">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.03] select-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/smoke_and_go_logo_watermark.png" alt="" className="w-[120%] max-w-none md:w-[80%] md:max-w-4xl object-contain" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4 text-primary">
            מה אומרים הקרניבורים
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            הלקוחות שלנו כבר התמכרו לטעם המעושן. הנה מה שהיה להם להגיד על החוויה.
          </p>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-4xl mx-auto">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="md:basis-full">
                <div className="flex flex-col items-center text-center px-4 md:px-12 py-6">
                  {}
                  <div className="mb-8 relative">
                    <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full transform scale-110"></div>
                    <SafeHydrate><Avatar className="size-24 md:size-32 border-4 border-background shadow-xl relative z-10">
                      <AvatarImage src={item.avatar} alt={item.name} className="object-cover" />
                      <AvatarFallback className="text-2xl bg-muted text-muted-foreground">
                        {item.name[0]}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                  </div>

                  {}
                  <div className="flex gap-1 mb-6">
                    {Array.from({
                  length: item.rating
                }).map((_, starIndex) => <Star key={starIndex} className="size-6 fill-primary text-primary" />)}
                  </div>

                  {}
                  <blockquote className="text-xl md:text-3xl font-medium leading-relaxed mb-8 text-foreground/90 max-w-3xl">
                    &ldquo;{item.quote}&rdquo;
                  </blockquote>

                  {}
                  <div className="flex flex-col items-center">
                    <cite className="not-italic font-bold text-lg md:text-xl text-primary">
                      {item.name}
                    </cite>
                    <span className="text-muted-foreground text-sm md:text-base mt-1">
                      {item.role}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex items-center justify-center gap-6 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 border-2 border-muted hover:border-primary hover:bg-primary hover:text-primary-foreground transition-colors bg-transparent text-muted-foreground" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-12 border-2 border-muted hover:border-primary hover:bg-primary hover:text-primary-foreground transition-colors bg-transparent text-muted-foreground" />
          </div>
        </Carousel>
      </div>
    </section>;
}